module.exports = __webpack_public_path__ + "img/Banner_CaaS(CN).657b1e79.png";